export enum AppTab {
  DASHBOARD = 'dashboard',
  IN_PROGRESS = 'freight-inprogress',
  FINISHED = 'freight-finished',
  FREIGHT_AVAILABLE = 'freight-available',
  SHIP_PENDING = 'freight-ship-pending',
  SHIP_IN_PROGRESS = 'freight-ship-inprogress',
  SHIP_FINISHED = 'freight-ship-finished',
  DECA_TODAY = 'deca-today',
}
// TODO use this enum in tabs.routes.ts in shippers app.
